import { endpoints } from '../constants/endpoints'

const getOldCompanyId = id => (id ? id.replace(/\D/g, '') : '')

export const createCompanyLogoUrl = companyId => {
  const oldCompanyId = getOldCompanyId(companyId)

  return `${endpoints.companyLogos}${oldCompanyId}.jpg`
}
